import React from 'react';
import '../App.css';

function Home() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Tools</h1>
      </header>
    </div>
  );
}

export default Home; 